import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import { getCentAmount } from "../../../../util/helper/getCentAmount";
import { parseDollarAmt } from "../../../../util/helper/parseDollarAmt";
import styles from "./was-price.module.scss";

function WasPrice(props: any) {
  const router = useRouter();
  const { locale } = router;
  const {
    product, wasPrice = product.wasPrice, price = product.price, compact = false,
  } = props;

  if (wasPrice <= price) {
    return null;
  }

  return (
    <>

      <div className={styles.old_price} data-clarity-unmask="true">

        <strike className={styles.was_price}>
          <HideIf show={locale === "en"}>
            CA&#36;
          </HideIf>
          <HideIf show={!compact}>
            {" "}
          </HideIf>

          <span>{parseDollarAmt(wasPrice)}</span>
          .

          <span>{getCentAmount(wasPrice)}</span>
          <HideIf show={locale === "fr"}>
            &nbsp;CA&#36;
          </HideIf>

        </strike>
      </div>
    </>
  );
}

export default WasPrice;
